// eslint-disable-next-line import/no-unresolved
import { RawDraftContentBlock } from 'draft-js';
import { Node } from 'slate';

export const unsupportedType = 'unsupported' as const;

export type UnsupportedElement = {
  type: typeof unsupportedType;
  legacyContent: RawDraftContentBlock;
  children: Node[];
};
